import { render, staticRenderFns } from "./battleReport.vue?vue&type=template&id=56d94a7c&scoped=true"
import script from "./battleReport.vue?vue&type=script&lang=js"
export * from "./battleReport.vue?vue&type=script&lang=js"
import style0 from "./battleReport.vue?vue&type=style&index=0&id=56d94a7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d94a7c",
  null
  
)

export default component.exports